import "./StockInTransit.scss";

export default function StockInTransit() {
  return (
    <section className="sales-layout__page stock-in-transit">
      <h1>Schwebelager</h1>
      <p>Hier werden zukünftig die Bestände im Schwebelager angezeigt.</p>
    </section>
  );
}
